export function hasTenantPermission(permissionName) {
  const { token } = this.getToken()
  if (token == null) return false

  console.log('in hasTenantPermission..................')

  //
  const decodedToken = JSON.parse(atob(token.split('.')[1]))

  const isaTenant = decodedToken['khoala-claim:istenant']
  //

  console.log('decodedToken=' + JSON.stringify(decodedToken))

  const tenantPermissions = decodedToken['khoala-claim:permissions']
  console.log('tenantPermissions=' + JSON.stringify(tenantPermissions))
  let permissionSet = false

  const tenantPermissionsFlat = JSON.stringify(tenantPermissions)
  if (tenantPermissionsFlat.indexOf(permissionName) !== -1 && isaTenant !== undefined) {
    permissionSet = true
  }

  if (isaTenant === undefined) {
    console.debug('is a tenant no')
    permissionSet = true
  }

  console.log('checking ' + permissionName + ' = ' + permissionSet)

  return permissionSet
}
